/**
 * =============================================================================
 * API Health Helpers (issue #19)
 * =============================================================================
 *
 * The dashboard shows the deployed backend version, which the BE reports on
 * its unauthenticated GET /health endpoint (admin-portal-be issue #34).
 *
 * /health lives at the backend root, OUTSIDE the /api/v1 prefix, so the URL
 * has to be derived from the configured API base URL:
 * - "/api/v1"              -> "/health"  (same-origin; nginx proxies it)
 * - "https://host/api/v1"  -> "https://host/health"
 */

/** Derive the BE /health URL from the configured API base URL. */
export function deriveHealthUrl(apiBaseUrl: string): string {
  const trimmed = apiBaseUrl.trim().replace(/\/+$/, '')
  const stripped = trimmed.replace(/\/api(\/v\d+)?$/, '')
  return `${stripped}/health`
}

/**
 * Resolve the API version string for display.
 *
 * Falls back to an em dash when the health response is missing, has no
 * version field (older BE), or the value is blank.
 */
export function resolveApiVersion(raw: string | undefined | null): string {
  const version = raw?.trim()
  return version ? version : '—'
}
